import hyperdom from 'hyperdom'
const cutOffDate = new Date('2018-06-01')
import dateformat from 'dateformat'
import {Message, MessageTypes} from './message.jsx'

export default function ({browserCapabilities}) {
  if (!browserCapabilities.tls11) {
    return hyperdom.viewComponent({
      onadd () {
        document.body.classList.add('ie-warning')
      },

      onremove () {
        document.body.classList.remove('ie-warning')
      },

      render () {
        return <div class='browser-warning'>
          {new Message({
            message: `We know holidays are important to you but so is online security. This browser (${browserCapabilities.browser.name.toUpperCase()} ${browserCapabilities.browser.version}) won't be supported from ${dateformat(cutOffDate, 'UTC:mmmm yyyy')}. We ask you to please upgrade your browser for a more secure and better experience.`,
            type: MessageTypes.WARNING,
          })}
        </div>
      },
    })
  }
}
